/* eslint-disable @typescript-eslint/naming-convention */
import { i18n } from '@/i18n';

/**
 * 任务类型列表: 限时任务, 新手任务, 专属任务, 基础任务，按照优先级排序
 * 2022-09-26优化：基础任务>专属任务>限时任务
 * */
export const taskTypeList = ['basic', 'newUser', 'special', 'limit'] as const;
/** 任务类型 */
export type TaskType = typeof taskTypeList[number];

/** 任务组配置 */
export const taskGroupConfig: {
  /** 任务类型 */
  type: TaskType;
  /** 任务组icon */
  icon: string;
  /** 任务标题 */
  title: string;
}[] = [
  {
    type: 'basic',
    icon: 'task-basic',
    title: i18n('基礎任務'),
  },
  {
    type: 'special',
    icon: 'task-special',
    title: i18n('專屬任務'),
  },
  {
    type: 'newUser',
    icon: 'task-new-user',
    title: i18n('新手任務'),
  },
  {
    type: 'limit',
    icon: 'task-limit',
    title: i18n('限時任務'),
  },
];

/**
 * 获取任务组配置
 * @param taskType 任务类型
 */
export function getTaskGroupConfig(taskType: TaskType) {
  return taskGroupConfig.find(item => item.type === taskType)!;
}
